import ImagePreview from "./components/ImagePreview";
import React from "react";
import { SubFormTable } from "./components/Form";
import jwt_decode from "jwt-decode";

export const getAuthorizedView = (auth, views) => {
	const view = views[auth] || views["none"];

	return view;
};

export const lastChanged = (ms) => {
	let now = Date.now(),
		milliseconds = now - ms,
		seconds = milliseconds / 1000,
		minutes = seconds / 60,
		hours = minutes / 60,
		days = hours / 24,
		weeks = days / 7,
		months = days / 30,
		years = days / 365,
		divs = {
			milliseconds,
			seconds,
			minutes,
			hours,
			days,
			weeks,
			months,
			years,
		},
		vals = Object.values(divs),
		keys = Object.keys(divs),
		delta = Object.keys(divs).length;

	while (delta--) {
		if (Math.floor(vals[delta]) > 0) break;
	}

	let amount = Math.floor(vals[delta]),
		unit = amount === 1 ? keys[delta].slice(0, -1) : keys[delta]; // 1 day, 2 days

	// e.g. 3 seconds ago
	return `${amount} ${unit}`;
};

export const API_ROOT =
	window.location.hostname === "localhost" ||
	window.location.hostname === "127.0.0.1" ||
	window.location.hostname === ""
		? "http://localhost:4999/api/v1"
		: "https://api.resinbonded.training/api/v1";

// A response that isn't our own JSON — a proxy error page, an empty body, a
// gateway timeout. The status is all we have to go on, so say something the
// user can act on rather than showing them a wall of HTML.
const describeStatus = (status, text) => {
	switch (status) {
		case 0:
			return "Could not reach the server. Check your connection and try again.";
		case 408:
		case 504:
			return "The server took too long to respond. If this record has a lot of photos, try removing some.";
		case 413:
			return "This record is too large to save. Please remove some photos and try again.";
		case 502:
		case 503:
			return "The server is unavailable. Please try again in a moment.";
		default:
			break;
	}

	// Don't show markup to the user
	const plain = (text || "").trim();

	return plain && !plain.startsWith("<")
		? plain.slice(0, 200)
		: `The server returned an unexpected response (${status}).`;
};

export const request = async (url, props = {}) => {
	console.info("URL", url);

	let response;

	try {
		// Stringify body
		props.body = JSON.stringify(props.body);

		// Request headers
		props.headers = {
			"Content-Type": "application/json",
			Authorization: `Bearer: ${localStorage.getItem("token")}`,
		};

		response = await fetch(API_ROOT + url, props);
	} catch (ex) {
		// Network-level failure: offline, DNS, connection reset mid-upload
		console.error(ex);

		return { success: false, status: 0, error: describeStatus(0) };
	}

	const { status } = response;

	let text = "",
		json = null;

	try {
		text = await response.text();
		json = text ? JSON.parse(text) : null;
	} catch (ex) {
		// Not JSON. `json` stays null and the status describes the failure.
		console.error(ex);
	}

	if (status === 401 && window.location.pathname.length > 1) {
		// redirect
		window.location.href = "/";

		return { success: false, status, error: "Your session has expired." };
	}

	// Every caller destructures the result, so this must always be an object
	// — returning undefined here turns a server error into a dead button.
	if (status >= 400 || !json || typeof json !== "object")
		return {
			success: false,
			status,
			error: (json && json.error) || describeStatus(status, text),
		};

	return json;
};

// A field is identified by its `uid`, so a change reported without one cannot
// be placed. It used to match the first field that also had none —
// `undefined === undefined` — and overwrite it, which is how adding a second
// item to one list destroyed an unrelated field on the same record.
export const hasFieldIdentity = (field) =>
	!!field && field.uid !== undefined && field.uid !== null && field.uid !== "";

export const applyFieldChange = (fields, inputState) => {
	if (!hasFieldIdentity(inputState)) return fields;

	// A copy, so a stale render's `record` can't be written through
	const next = [...fields];
	const index = next.findIndex((field) => field.uid === inputState.uid);

	if (index !== -1) next[index] = inputState;
	else next.push(inputState);

	return next;
};

// Object to query string
export const toQuery = (params) => {
	return typeof params === "object"
		? "?" + new URLSearchParams(params).toString()
		: params;
};

export const switchTableData = ({ type, checked, value, items }) => {
	switch (type) {
		case "image":
			return <ImagePreview src={value} />;
		case "list":
			return <SubFormTable items={items} />;
		case "checkbox":
			return <p>{JSON.parse(checked) === true ? "Yes" : "No"}</p>;
		case "date":
			return <p>{value && new Date(value).toLocaleDateString()}</p>;
		default:
			return <p>{value}</p>;
	}
};

export const getUserId = () => jwt_decode(localStorage.getItem("token"))._id;
export const getUserAuth = () => jwt_decode(localStorage.getItem("token")).auth;

String.prototype.capitalize = function () {
	return this[0].toUpperCase() + this.substring(1, this.length);
};
